// Hands a file to the person: the app's own save hook when there is one (tests), otherwise a browser download.
export function saveBlobFile(blob, filename) {
  if (window.__prismSave) return window.__prismSave(blob, filename);
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob); a.download = filename;
  document.body.appendChild(a); a.click();
  setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  return Promise.resolve(true);
}
